<template>
  <article :id="id" :class="{ hidden: hidden }">
    <heading v-if="title" ref="header" class="title" tag="h2" icon="">
      {{ title }}
    </heading>

    <div class="grid">
      <slot />
    </div>
  </article>
</template>
<script lang="ts" setup>
interface Props {
  title?: string | null;
  hidden?: boolean;
  id?: string;
}
const props = defineProps({
  title: { default: null },
  hidden: { type: Boolean, default: false },
  id: null
});

const header = ref<HTMLElement>(null);

useAnchorElement(header, props.id, props.title);
</script>
<style lang="scss" scoped>
article {
  &.hidden {
    display: none;
  }

  display: flex;
  gap: var(--gap_n);
  flex-direction: column;
}
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(13.2rem, 1fr));
  width: 100%;
  gap: var(--gap_n);
}
.grid-by-2 {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(26.4rem, 1fr));
  width: 100%;
  gap: var(--gap_n);
}
</style>
